/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { RouterContext } from '@atlassian/react-resource-router';

type SurveysEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{
		context: RouterContext;
	}
>;

export const surveysEntryPoint: EntryPoint<SurveysEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForInteraction<SurveysEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-surveys-smart-create", jiraSpaEntry: "async-servicedesk-surveys-smart-create" */ './SmartSurveyCreate.tsx',
		),
		getPreloadProps: ({ context }: EntryPointRouteParams) => ({
			extraProps: {
				context,
			},
		}),
	});
